// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 9066 ? "dc112a36" : chunkId) + "." + {"8444":"f1bed5ad45971375","9066":"9ce6d67ac745b612"}[chunkId] + ".js";
};